import React from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/common/tip/Tooltip.tsx'
import { cn } from '@/lib/utils.ts'
import { SIDE_OPTIONS } from '@radix-ui/react-popper'
import { useTranslation } from 'react-i18next'

type TipProps = React.PropsWithChildren<{
  content?: string | React.ReactNode
  className?: string
  contentClassName?: string
  side?: (typeof SIDE_OPTIONS)[number]
  disabled?: boolean
  defaultContent?: boolean
}>
export const Tip = ({
  content,
  children,
  className,
  contentClassName,
  disabled,
  side = 'top',
  defaultContent,
}: TipProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const delay = 400

  const actionNotAllowedTip = <span> ℹ️ {t(`common.actionNotAllowed`)}</span>

  if (defaultContent) content = actionNotAllowedTip

  function toggle(e: React.TouchEvent) {
    e.preventDefault()
    e.stopPropagation()
    setOpen(curr => !curr)
  }

  if (disabled) return <>{children}</>

  function handleMouseEvent(event: 'mouseenter' | 'mouseleave') {
    setTimeout(() => {
      if (event === 'mouseenter') setOpen(true)
      if (event === 'mouseleave') setOpen(false)
    }, delay)
    setOpen(true)
  }

  return (
    <TooltipProvider delayDuration={delay}>
      <Tooltip open={disabled ? false : open}>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            role={`button`}
            // type="button"
            className={cn('cursor-pointer', className)}
            onMouseEnter={() => handleMouseEvent(`mouseenter`)}
            onMouseLeave={() => handleMouseEvent(`mouseleave`)}
            onTouchStart={e => toggle(e)}
            onKeyDown={e => {
              e.preventDefault()
              e.key === 'Enter' && setOpen(!open)
            }}
          >
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className={cn(`max-w-[90vw]`, contentClassName, !content ? 'hidden' : '')}
        >
          <span className="inline-block">{content}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
